import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

export const findParentPage = (
  parent: ContentNode,
  node: ContentNode,
  // @ts-expect-error TS2366 - strict migration
): { parent: ContentNode; pageIdx: number } => {
  for (const [idx, p] of parent.subContent.entries()) {
    if (p.id === node.id) {
      return { parent, pageIdx: idx };
    } else {
      const newParent = findParentPage(p, node);
      if (newParent) {
        return newParent;
      }
    }
  }
};
